import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, Model_VariableEnvironnement } from 'src/app/app.models';
import { COMPONENT_MODE } from '../workflow-components.models';

export class Model_WorkflowDatasourcePickerComponent extends Model_WorkflowComponent {
    workflowComponents?: Model_WorkflowComponent[];
    gridComponents?: Model_WorkflowComponent[];
    variablesEnvironnement?: Model_VariableEnvironnement[];
}
  
export interface DatasourcePickerModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
    workflowComponents: Model_WorkflowComponent[];
    gridComponents?: Model_WorkflowComponent[];
    variablesEnvironnement: Model_VariableEnvironnement[];
	hasDatasourceFilters: boolean;
	hasCacheOption: boolean;
}
  
export class DatasourcePickerModel extends DynamicInputModel {
	@serializable() readonly type: string = 'datasource_picker';
	componentMode: COMPONENT_MODE;
    workflowComponents: Model_WorkflowComponent[];
    gridComponents?: Model_WorkflowComponent[];
    variablesEnvironnement: Model_VariableEnvironnement[];
	hasDatasourceFilters: boolean;
	hasCacheOption: boolean;

	constructor(config: DatasourcePickerModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
        this.workflowComponents = config.workflowComponents;
		this.gridComponents = config.gridComponents;
        this.variablesEnvironnement = config.variablesEnvironnement;
		this.hasDatasourceFilters = config.hasDatasourceFilters;
		this.hasCacheOption = config.hasCacheOption;
	}

	public static initModel(_component: Model_WorkflowDatasourcePickerComponent) {
		const formModel = new DatasourcePickerModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
            additional: _component,
			relations: _component.RELATIONS,
			workflowComponents: _component.workflowComponents || [],
			gridComponents: _component.gridComponents,
			variablesEnvironnement: _component.variablesEnvironnement || [],
			hasDatasourceFilters: _component.HAS_DATASOURCE_FILTERS ?? true,
			hasCacheOption: _component.HAS_CACHE_OPTION ?? true,
		});
		return formModel;
	}
}
  